export default __webpack_public_path__ + "static/media/image.0f173d31.svg";